const HELP_TEXT = (approvalRoles = []) => ({
  customMessage: {
    approval: `The roles which can approve or deny this change request are: ${approvalRoles.join(
      ', ',
    )}`,
  },
});

export default HELP_TEXT;
